export const chat = {
  online: "Online",
  offline: "Offline",
  noMessages: "No messages yet. Start the conversation!",
  typeMessage: "Type a message...",
  sendFailed: "Failed to send message: %{error}",
  messageDeleted: "This message was deleted",
  privateNote: "Private note - only visible to agents",
  privateLabel: "Private",
  edited: "Edited",
  attachment: "Attachment",
  file: "File",
  image: "Image",
  fileNotAvailable: "File not available",
  audioNotSupported: "Audio not supported",
  videoNotSupported: "Video not supported",
  media: "Media",
  fileCannotBePreview: "File cannot be previewed",
  downloadFile: "Download file",
  unknownSender: "Unknown",
  unknownContact: "Unknown contact",
  selectConversation: "Select a conversation",
  selectConversationHint:
    "Choose a conversation from the list on the left to start",
  noConversationSelected: "No conversation selected",
  noTicketMessage: "Select a ticket to view the conversation",
  noTicketSelected: "No ticket selected",
  selectTicketToView:
    "Select a ticket to view the conversation",
  startConversation: "Start conversation",
  startConversationHint: "Start the conversation!",
  loadMore: "Load more messages",
  toggleDetails: "Toggle details",
  details: "Details",
  attachFile: "Attach file",
  addEmoji: "Add emoji",
  quickReplies: "Quick replies",
  quickReplySearch: "Search quick reply...",
  noQuickReplies: "No quick replies found",
  pasteImage: "Pasted image",
  fileTooLarge:
    "%{provider} limits uploads to %{maxSize}. File skipped: %{files}",
  sendError: "Failed to send message. Please try again.",
  forwarded: "Forwarded",
  ephemeral: "Disappearing message",
  forward: {
    title: "Forward message",
    forwarding: "Forwarding:",
    searchContact: "Search contact...",
    send: "Forward",
    success: "Message forwarded",
    noConversation:
      "No conversation found for this contact",
    noResults: "No contacts found",
    typeToSearch: "Type to search contacts",
    group: "Group",
  },
  provider: "The provider",
  messageInput: "Message input",
  typing: {
    one: "%{name} is typing",
    two: "%{name1} and %{name2} are typing",
    many: "%{count} people are typing",
    someone: "Someone",
  },
  time: {
    justNow: "Just now",
    minutesAgo: "%{count}m ago",
    hoursAgo: "%{count}h ago",
    today: "Today",
    yesterday: "Yesterday",
    daysAgo: "%{count} days ago",
  },
  attachments: {
    image: "Image",
    video: "Video",
    audio: "Audio",
    document: "Document",
    unknownType: "Unknown type",
    dragDrop: "Drag files here or click to select",
    limits: "Maximum %{maxFiles} files, up to %{maxSize}MB each",
    maxFilesExceeded: "Maximum of %{max} files allowed",
    fileTooLarge:
      "File %{name} is too large. Maximum: %{maxSize}MB",
    duplicate: "File %{name} has already been added",
    addMore: "Add more files",
    maxReached: "Maximum of %{max} files reached",
  },
  muteConversation: "Mute conversation",
  unmuteConversation: "Unmute conversation",
  blockContact: "Block contact",
  editChannel: "Edit Channel",
  addMembers: "Add Members",
  leaveConversation: "Leave Conversation",
  deleteConversation: "Delete Conversation",
  conversationUpdated: "Conversation updated successfully",
  conversationDeleted: "Conversation deleted successfully",
  participantsAdded: "Participants added successfully",
  participantRemoved: "Participant removed successfully",
  leftConversation: "You left the conversation",
  updateError: "Error updating conversation",
  deleteError: "Error deleting conversation",
  addParticipantsError: "Error adding participants",
  removeParticipantError: "Error removing participant",
  leaveError: "Error leaving conversation",
  cannotLeaveOnlyParticipant:
    "You are the only participant in this conversation. Consider deleting it instead.",
  messageEdited: "Message edited successfully",
  messageDeletedSuccess: "Message deleted successfully",
  editMessageError: "Error editing message",
  editMessageForbidden: "You cannot edit this message",
  editMessageExpired:
    "The time to edit this message has expired",
  deleteMessageError: "Error deleting message",
  deleteMessageForbidden: "You cannot delete this message",
  deleteMessageExpired:
    "The time to delete this message has expired",
  confirmLeave: "Leave Conversation",
  confirmLeaveMessage:
    "Are you sure you want to leave this conversation? You will no longer receive messages from this group.",
  confirmDelete: "Delete Conversation",
  confirmDeleteMessage:
    "Are you sure you want to delete this conversation? This action cannot be undone and the conversation will be removed for all participants.",
  moreOptions: "More options",
  connection: {
    connected: "Connected",
    disconnected: "Disconnected",
    reconnecting: "Reconnecting...",
    reconnectFailed: "Reconnection failed",
    reconnectFailedMessage:
      "Could not reconnect to server. Please refresh the page.",
    prolongedDisconnection:
      "The connection is taking a while to restore.",
    checkConnectionSuggestion:
      "Check your internet connection and consider refreshing the page.",
    attempt: "Attempt",
    refresh: "Refresh page",
    dismiss: "Dismiss",
  },
  tags: {
    noTags: "No tags",
    selectTag: "Select tag",
    noAvailableTags: "No tags available",
    added: "Tag added successfully",
    removed: "Tag removed successfully",
    addError: "Error adding tag",
    removeError: "Error removing tag",
  },
  poll: {
    title: "Poll",
    multipleChoice: "multiple choice",
    closed: "Closed",
    yourVote: "Your vote",
    totalVotes: "%{count} vote |||| %{count} votes",
  },
  preview: {
    image: "Photo",
    video: "Video",
    audio: "Voice message",
    document: "Document",
    sticker: "Sticker",
    location: "Location",
    liveLocation: "Live location",
    contact: "Contact",
    contactCard: "Contact card",
    poll: "Poll",
    call: "Call",
    system: "System message",
  },
  systemEvents: {
    new_chat_members: "joined the group",
    left_chat_member: "left the group",
    new_chat_title: "Group was renamed",
    new_chat_photo: "Group photo was updated",
    delete_chat_photo: "Group photo was removed",
    group_chat_created: "Group created",
    supergroup_chat_created: "Supergroup created",
    channel_chat_created: "Channel created",
    pinned_message: "Message pinned",
    migrate_to_supergroup: "Group upgraded to supergroup",
    forum_topic_created: "Topic created",
    forum_topic_closed: "Topic closed",
    forum_topic_reopened: "Topic reopened",
    forum_topic_edited: "Topic edited",
    video_chat_started: "Video chat started",
    video_chat_ended: "Video chat ended",
    video_chat_participants_invited:
      "Participants invited to video chat",
    unsupported_message_type: "Unsupported message type",
  },
};
